import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Dashboard from './components/Dashboard';
import LoginRegistrationPage from './components/LoginRegistrationPage';
import ScreenRegistration from './components/ScreenRegistration';
import AdPublisherDashboard from './components/AdPublisherDashboard';
import Analytics from './components/Analytics';


function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login-registration-page" element={<LoginRegistrationPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/register-screen" element={<ScreenRegistration />} />
          <Route path="/advertiser-dashboard" element={<AdPublisherDashboard />} />
          <Route path="/analytics" element={<Analytics />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;